export interface SMSTemplate {
  id: string;
  name: string;
  content: string;
  category: "payment" | "promotion" | "reminder" | "alert";
  charCount: number;
}

export interface AudienceSegment {
  id: string;
  name: string;
  count: number;
  description: string;
  color: string;
}

export interface SMSCampaign {
  id: string;
  name: string;
  template: string;
  audience: string;
  status: "draft" | "scheduled" | "sending" | "completed" | "failed";
  scheduledAt: string;
  sent: number;
  delivered: number;
  failed: number;
  createdAt: string;
}

export const smsTemplates: SMSTemplate[] = [
  { id: "t1", name: "Payment Reminder", content: "Dear {name}, your loan payment of KES {amount} is due on {date}. Pay via M-Pesa to avoid penalties. Ref: {ref}", category: "reminder", charCount: 128 },
  { id: "t2", name: "Payment Received", content: "Hi {name}, we've received your payment of KES {amount}. Your balance is KES {balance}. Thank you for banking with us!", category: "payment", charCount: 112 },
  { id: "t3", name: "New Loan Offer", content: "Congratulations {name}! You qualify for a loan of up to KES {amount} at {rate}% interest. Apply now at {link}", category: "promotion", charCount: 108 },
  { id: "t4", name: "Overdue Notice", content: "URGENT: {name}, your payment of KES {amount} is {days} days overdue. Contact us immediately at {phone} to avoid further action.", category: "alert", charCount: 132 },
  { id: "t5", name: "Disbursement Confirmation", content: "Dear {name}, KES {amount} has been disbursed to your account {account}. Repayment starts on {date}. Terms apply.", category: "payment", charCount: 118 },
  { id: "t6", name: "Early Settlement Offer", content: "Hi {name}, settle your loan early and save KES {savings}! Contact us or visit {link} for details. Offer valid till {date}.", category: "promotion", charCount: 124 },
];

export const audienceSegments: AudienceSegment[] = [
  { id: "a1", name: "All Customers", count: 24891, description: "Every registered customer", color: "hsl(173, 58%, 39%)" },
  { id: "a2", name: "Active Borrowers", count: 12455, description: "Customers with active loans", color: "hsl(199, 89%, 48%)" },
  { id: "a3", name: "Overdue Accounts", count: 3201, description: "Accounts past due date", color: "hsl(0, 72%, 51%)" },
  { id: "a4", name: "Qualified Leads", count: 8734, description: "Pre-approved for new loans", color: "hsl(43, 96%, 56%)" },
  { id: "a5", name: "Dormant Accounts", count: 5102, description: "No activity in 90+ days", color: "hsl(262, 52%, 47%)" },
];

export const smsCampaigns: SMSCampaign[] = [
  { id: "c1", name: "February Payment Reminders", template: "Payment Reminder", audience: "Active Borrowers", status: "completed", scheduledAt: "2026-02-15 09:00", sent: 12455, delivered: 12102, failed: 353, createdAt: "2026-02-14" },
  { id: "c2", name: "Q1 Loan Promo", template: "New Loan Offer", audience: "Qualified Leads", status: "completed", scheduledAt: "2026-02-01 10:00", sent: 8734, delivered: 8501, failed: 233, createdAt: "2026-01-30" },
  { id: "c3", name: "Overdue Collection Wave", template: "Overdue Notice", audience: "Overdue Accounts", status: "sending", scheduledAt: "2026-02-21 08:00", sent: 1800, delivered: 1756, failed: 44, createdAt: "2026-02-20" },
  { id: "c4", name: "Early Settlement Campaign", template: "Early Settlement Offer", audience: "Active Borrowers", status: "scheduled", scheduledAt: "2026-02-25 11:00", sent: 0, delivered: 0, failed: 0, createdAt: "2026-02-21" },
  { id: "c5", name: "Re-engagement Drive", template: "New Loan Offer", audience: "Dormant Accounts", status: "draft", scheduledAt: "", sent: 0, delivered: 0, failed: 0, createdAt: "2026-02-21" },
  { id: "c6", name: "January Disbursement Confirm", template: "Disbursement Confirmation", audience: "Active Borrowers", status: "completed", scheduledAt: "2026-01-20 14:00", sent: 11200, delivered: 10988, failed: 212, createdAt: "2026-01-19" },
];

export const smsAnalytics = {
  totalSent: 45189,
  totalDelivered: 43847,
  totalFailed: 1342,
  deliveryRate: 97.03,
  avgResponseRate: 12.4,
  costPerSMS: 0.35,
  totalCost: 15816,
  monthlyData: [
    { month: "Sep", sent: 3200, delivered: 3104, cost: 1120 },
    { month: "Oct", sent: 4100, delivered: 3977, cost: 1435 },
    { month: "Nov", sent: 5800, delivered: 5626, cost: 2030 },
    { month: "Dec", sent: 6200, delivered: 6014, cost: 2170 },
    { month: "Jan", sent: 8500, delivered: 8245, cost: 2975 },
    { month: "Feb", sent: 9200, delivered: 8881, cost: 3220 },
  ],
};
